import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import apiInstance from '../../Apis/Axios';
import { t } from 'i18next';
import {ATTENDANCE_SERVICE, EMAIL_SETTINGS_SERVICE, FILE_SERVICE, USER_SERVICE} from '../EndPoints';

/*
Author : Arman Ali
Module: Zone
github: https://github.com/Arman-Arzoo
*/

// device Api payroll

export const GetAllSelectedDevice = createAsyncThunk('employeePayRoll/getAllSelectedDevice', async () => {
    const response = await apiInstance
        .get(EMAIL_SETTINGS_SERVICE.getAllSelectedDevice)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetColorAttendance = createAsyncThunk('employeePayRoll/getColorAttendance ', async () => {
    const response = await apiInstance
        .get(ATTENDANCE_SERVICE.getColorAttendance)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAttendanceDepartments = createAsyncThunk('employeePayRoll/getAttendanceDepartments', async () => {
    const response = await apiInstance
        .get(ATTENDANCE_SERVICE.getAttendanceDepartments)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const CreateAttendanceDepartment = createAsyncThunk(
    'employeePayRoll/createAttendanceDepartment',
    async (params) => {
        const response = await apiInstance
            .post(ATTENDANCE_SERVICE.createAttendanceDepartment, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const UpdateAttendanceDepartment = createAsyncThunk(
    'employeePayRoll/updateAttendanceDepartment',
    async (params) => {
        const response = await apiInstance
            .put(ATTENDANCE_SERVICE.updateAttendanceDepartment, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const AddDeviceToListPayroll = createAsyncThunk('employeePayRoll/addDeviceToListPayroll', async (params) => {
    const response = await apiInstance
        .post( `${EMAIL_SETTINGS_SERVICE.addDeviceToListPayroll}${params?.device?.id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const DeleteDeviceToListPayroll = createAsyncThunk(
    'employeePayRoll/deleteDeviceToListPayroll',
    async (params) => {
        const response = await apiInstance
            .delete(`${EMAIL_SETTINGS_SERVICE.deleteDeviceToListPayroll}${params}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const GetAllSelectedEmployees = createAsyncThunk('employeePayRoll/getAllSelectedEmployees', async (params) => {
    const response = await apiInstance
        .post(EMAIL_SETTINGS_SERVICE.getAllSelectedEmployees, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});


export const GetAllOnlyUserData = createAsyncThunk('employeePayRoll/getAllOnlyUserData', async (params) => {
    const response = await apiInstance
        .get(EMAIL_SETTINGS_SERVICE.getAllOnlyUserData)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const updateUserEmailByList = createAsyncThunk('employeePayRoll/updateUserEmailByList', async (params) => {
    const response = await apiInstance
        .put(EMAIL_SETTINGS_SERVICE.updateUserEmailByList, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const AddEmployeesToListPayroll = createAsyncThunk(
    'employeePayRoll/addEmployeesToListPayroll',
    async (params) => {
        const response = await apiInstance
            .post(`${EMAIL_SETTINGS_SERVICE.addEmployeesToListPayroll}${params?.user?.id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

export const DeleteEmployeesToListPayroll = createAsyncThunk(
    'employeePayRoll/deleteEmployeesToListPayroll',
    async (params) => {
        const response = await apiInstance
            .delete(`${EMAIL_SETTINGS_SERVICE.deleteDeviceToListPayroll}${params}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

// Email setting Api Payroll

export const GetEmailSetting = createAsyncThunk('employeePayRoll/getEmailSetting', async () => {
    const response = await apiInstance
        .get(EMAIL_SETTINGS_SERVICE.getEmailSetting)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const UpdateEmailSetting = createAsyncThunk(
    'employeePayRoll/updateEmailSetting',
    async (params, { dispatch, getState }) => {
        let response = await apiInstance
            .put(EMAIL_SETTINGS_SERVICE.updateEmailSetting, params)
            .then((response) => {
                toast.success(t('has_been_updated_successfully').toUpperCase());
                return response;
            })
            .catch((error) => {
                toast.success(t('error_updating').toUpperCase());
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

// change the time or checkbox payroll
export const UpdateEmailSettingAttendanceManage = createAsyncThunk(
    'employeePayRoll/updateEmailSettingAttendanceManage',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .put(EMAIL_SETTINGS_SERVICE.updateEmailSettingAttendanceManage, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);

// remove devices
export const RemoveDeviceAttendance = createAsyncThunk(
    'employeePayRoll/removeDeviceAttendance',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(EMAIL_SETTINGS_SERVICE.removeDeviceAttendance, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
// remove employee
export const RemoveEmployeeAttendance = createAsyncThunk(
    'employeePayRoll/removeEmployeeAttendance',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(EMAIL_SETTINGS_SERVICE.removeEmployeeAttendance, params)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
//Export attendance module to email
export const CreateAttendanceExcelReport = createAsyncThunk(
    'employeePayRoll/createAttendanceExcelReport',
    async ({ body }, { dispatch, getState }) => {
        let result = await apiInstance
            .post(FILE_SERVICE.createAttendanceExcelReport, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status, code } = result;
        return { data, status, code };
    },
);
//Export attendance module to pdf
export const CreateAttendancePDFReport = createAsyncThunk(
    'employeePayRoll/createAttendancePDFReport',
    async ({ body }, { dispatch, getState }) => {
        let result = await apiInstance
            .post(FILE_SERVICE.createAttendancePDFReport, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;
        return { data, status };
    },
);
//Export attendance module to excel to email
export const CreateSimpleAttendanceExcelReport = createAsyncThunk(
    'employeePayRoll/createSimpleAttendanceExcelReport',
    async ({ body }, { dispatch, getState }) => {
        let result = await apiInstance
            .post(FILE_SERVICE.createSimpleAttendanceExcelReport, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;
        return { data, status };
    },
);
//Export attendance module to pdf to email
export const CreateSimpleAttendancePDFReport = createAsyncThunk(
    'employeePayRoll/createSimpleAttendancePDFReport',
    async ({ body }, { dispatch, getState }) => {
        let result = await apiInstance
            .post(FILE_SERVICE.createAttendancePDFReport, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;
        return { data, status };
    },
);

export const GetAllLocationsByDepartment = createAsyncThunk('attendanceService/getAllLocationsByDepartment',
    async ({ body }) => {
    const response = await apiInstance
        .post(ATTENDANCE_SERVICE.getAllLocationsByDepartment,body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GetAllLastEntryByUser = createAsyncThunk(
    'attendanceService/getAllLastEntryByUser',
    async ({ params }) => {
        try {
            const response = await apiInstance.get(
               ATTENDANCE_SERVICE.getAllLastEntryByUser(params?.id, params?.total)
            );

            const { data, status } = response;
            return { data, status };
        } catch (error) {
            return error.response;
        }
    }
);

export const GetUserById = createAsyncThunk('userService/getUserById',
    async ({ params }) => {
        const response = await apiInstance
            .get(`${USER_SERVICE.getUserById}${params.id}`,{ overlay: false })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    });

export const GetCustomAccessByShiftId = createAsyncThunk('employeePayRoll/getCustomAccessByShiftId', async (params) => {
    const response = await apiInstance
        .post(`${ATTENDANCE_SERVICE.getCustomAccessByShiftId}${params.id}`, params?.body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const IsAttendanceSupervisor = createAsyncThunk('attendancePersistService/isAttendanceSupervisor', async () => {
    const response = await apiInstance
        .get(`${ATTENDANCE_SERVICE.isAttendanceSupervisor}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const GetAttendanceDepartmentAssigned = createAsyncThunk('employeePayRoll/getAttendanceDepartmentAssigned', async () => {
    const response = await apiInstance
        .get(`${ATTENDANCE_SERVICE.getAttendanceDepartmentAssigned}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
